var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 10.2008H15.6V10.8821C16.2099 10.4746 16.919 10.2404 17.6516 10.2044C18.3843 10.1685 19.1129 10.3322 19.7597 10.6781C20.4066 11.024 20.9473 11.539 21.3243 12.1682C21.7012 12.7975 21.9002 13.5173 21.9 14.2508V19.2008H20.1V14.2508C20.1 12.9638 19.0425 12.0008 17.85 12.0008C16.6575 12.0008 15.6 12.9638 15.6 14.2508V19.2008H13.8V10.2008ZM12 4.80078V6.60078H4.8V11.1008H12V12.9008H4.8V17.4008H12V19.2008H3V4.80078H12Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishInput);
export default __webpack_public_path__ + "static/media/english-input.5d0d39d42eb0692dd93d2d7bdd612d6d.svg";
export { ForwardRef as ReactComponent };